import{useState as t}from"react";var e=function(){var e=t(""),r=e[0],n=e[1];return{selectText:function(){var t=window.getSelection()||"";t&&n(t.toString())},selectedText:r}};export{e as useSelectedText};
